import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import English from "./views/english.vue";
import Entrepreneurship from "./views/entrepreneurship.vue";
import FAQ from "./views/faq.vue";
import store from "./store";
import { CHECK_AUTH } from "./store/actions.type";
Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/entrepreneurship",
    name: "entrepreneurship",
    component: Entrepreneurship,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/english",
    name: "english",
    component: English,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/faq",
    name: "faq",
    component: FAQ,
    meta: {}
  }
];
// This callback runs before every route change, including on page load.
const router = new Router({
  mode: "history",
  routes,
  base: process.env.BASE_URL
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    return store.dispatch(CHECK_AUTH, "router").then(validUser => {
      if (validUser.status && validUser.status === 401) {
        // next();
        document.location.replace(validUser.data.destination_url);
      } else if (validUser.status === 200 || validUser.user) {
        next();
      } else {
        next({ name: "home" });
      }
    });
    // next()
  } else {
    next();
  }
});
export default router;
